import feather from "feather-icons";
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

document.cookie = 'post-protection=1; expires='
	+ (new Date(Date.now() + 86400 * 7 * 1000)).toGMTString()
	+ '; path=/; secure; samesite=none';


export function runOnPage(pageId, callback) {
	const currentPageId = document.documentElement.id;
	if (currentPageId === pageId && typeof callback === 'function') {
		callback();
	}
}


// COLOR EFFECT ON THE CURSOR
function initCursorEffect() {
	const container = document.getElementById('cursor-trail');
	if (!container) {
		return;
	}

	const trailCount = 4;
	const trailEls = [];
	const positions = [];
	for (let i = 0; i < trailCount; i++) {
		const el = document.createElement('div');
		el.className = 'cursor-effect';
		container.appendChild(el);
		trailEls.push(el);
		positions.push({x: window.innerWidth / 2, y: window.innerHeight / 2});
	}

	let mouse = {x: window.innerWidth / 2, y: window.innerHeight / 2};
	window.addEventListener('mousemove', (e) => {
		mouse.x = e.clientX;
		mouse.y = e.clientY;
	});

	gsap.ticker.add(() => {
		positions.forEach((pos, i) => {
			const target = i === 0 ? mouse : positions[i - 1];
			pos.x += (target.x - pos.x) * 0.2;
			pos.y += (target.y - pos.y) * 0.2;
			gsap.set(trailEls[i], {x: pos.x, y: pos.y});
		});
	});

	const hideTrail = () => container.style.display = 'none';
	const showTrail = () => container.style.display = 'block';
	document.querySelectorAll('.no-cursor-trail').forEach(el => {
		el.addEventListener('mouseenter', hideTrail);
		el.addEventListener('mouseleave', showTrail);
	});
}


document.addEventListener('DOMContentLoaded', () => {
	if (window.innerWidth > 1024) {
		initCursorEffect();
	}
});


// OUR TEAM NAVIGATION TABS
function initNavTabs() {
	const $tabs = $('.nav-tab');
	const $people = $('#gallery .group[data-category]');
	const $nav = $('nav[role="navigation"]');

	// Tabs switching
	$tabs.on('click', function () {
		const cat = $(this).data('category');
		$tabs.removeClass('nav-tab--active');
		$(this).addClass('nav-tab--active');
		if (cat === 'everyone') {
			$people.show();
		}
		else {
			$people.hide().filter(`[data-category="${cat}"]`).show();
		}
	});

	// Init correct default tab
	const defaultCat = window.innerWidth < 1024 ? 'management' : 'everyone';
	$tabs.filter(`[data-category="${defaultCat}"]`).trigger('click');

	// Drag-scroll (desktop)
	let isDown = false, startX = 0, scrollLeft = 0;
	$nav.on('mousedown', function (e) {
		if ($(e.target).is('button')) {
			return;
		}
		isDown = true;
		startX = e.pageX - $nav.offset().left;
		scrollLeft = $nav.scrollLeft();
		$nav.addClass('cursor-grabbing');
	});
	$(document).on('mousemove', function (e) {
		if (!isDown) {
			return;
		}
		const x = e.pageX - $nav.offset().left;
		$nav.scrollLeft(scrollLeft - (x - startX));
	});
	$(document).on('mouseup', function () {
		isDown = false;
		$nav.removeClass('cursor-grabbing');
	});

	// Touch-scroll (mobile)
	$nav.on('touchstart', function (e) {
		isDown = true;
		startX = e.originalEvent.touches[0].pageX - $nav.offset().left;
		scrollLeft = $nav.scrollLeft();
	});
	$nav.on('touchmove', function (e) {
		if (!isDown) {
			return;
		}
		const x = e.originalEvent.touches[0].pageX - $nav.offset().left;
		$nav.scrollLeft(scrollLeft - (x - startX));
	});
	$(document).on('touchend touchcancel', function () {
		isDown = false;
	});
}


// SHOW TWO LINES PROFILES
function initTeamProfiles() {
	const $grid  = $('#gallery .our-team');
	if ($grid.length === 0) return;

	const $cards = $grid.children('.relative.group');
	const $btn   = $('#showMore');

	// helper na přepočet GSAP nebo fallback scroll
	function refreshScroll() {
		if (typeof ScrollTrigger !== 'undefined') {
			ScrollTrigger.refresh();
		} else {
			window.dispatchEvent(new Event('scroll'));
		}
	}

	function colCount() {
		const gridEl = $grid.get(0);
		if (!gridEl) return 1;
		const gtc = getComputedStyle(gridEl)
			.getPropertyValue('grid-template-columns');
		const rep = gtc.match(/repeat\((\d+)/);
		return rep
			? +rep[1]
			: gtc.split(/\s+/).filter(Boolean).length || 1;
	}

	function refreshLimit(cat) {
		$cards.removeClass('hidden-by-limit');

		if (cat !== 'everyone' || window.innerWidth < 1024) {
			$btn.hide();
			return;
		}

		const limit = colCount() * 2;
		const $vis = $cards.filter(':visible');

		const showEls = [];
		const counts = {};
		$vis.each(function () {
			const c = $(this).data('category') || 'uncategorized';
			counts[c] = counts[c] || 0;
			if (counts[c] < 2) {
				showEls.push(this);
				counts[c]++;
			}
		});

		$vis.each(function () {
			if (showEls.length >= limit) {
				return false;
			}
			if (showEls.indexOf(this) === -1) {
				showEls.push(this);
			}
		});

		$vis.each(function () {
			if (showEls.indexOf(this) === -1) {
				$(this).addClass('hidden-by-limit');
			}
		});

		$btn.toggle($vis.length > showEls.length);
	}

	// změna kategorie
	$(document).on('click', '.nav-tab', function () {
		const cat = $(this).data('category') || 'everyone';
		refreshLimit(cat);
		refreshScroll();
	});

	// resize přepočet
	$(window).on('resize', function () {
		if ($('.nav-tab.nav-tab--active').data('category') === 'everyone') {
			refreshLimit('everyone');
			refreshScroll();
		}
	});

	// tlačítko "Show more"
	$btn.on('click', function () {
		$cards.removeClass('hidden-by-limit');
		$btn.hide();
		refreshScroll();
	});

	// initial
	refreshLimit('everyone');
}


// PLAY ANIMATIONS
function initLazyLoadVideos() {
	const observer = new IntersectionObserver((entries, obs) => {
		entries.forEach(entry => {
			if (!entry.isIntersecting) {
				return;
			}

			const video = entry.target;
			if (video.dataset.loaded) {
				return;
			}

			if (video.dataset.srcWebm) {
				const sWebm = document.createElement('source');
				sWebm.src = video.dataset.srcWebm;
				sWebm.type = 'video/webm';
				video.appendChild(sWebm);
			}
			if (video.dataset.srcMp4) {
				const sMp4 = document.createElement('source');
				sMp4.src = video.dataset.srcMp4;
				sMp4.type = 'video/mp4';
				video.appendChild(sMp4);
			}

			video.load();
			video.dataset.loaded = '1';
			obs.unobserve(video);
		});
	}, {rootMargin: '200px'});

	document
		.querySelectorAll('video.video-thumb[data-src-mp4], video.video-thumb[data-src-webm]')
		.forEach(v => observer.observe(v));
}


function initHoverPlayVideos() {
	$('video.video-thumb').each(function () {
		const video = this;

		video.addEventListener('loadeddata', () => {
			video.currentTime = 0.001;
			video.pause();
			video.style.opacity = '0.5';
		});
	});

	$(document).on('mouseenter', 'video.video-thumb', function () {
		if (window.matchMedia('(max-width: 420px)').matches) {
			return;
		} // jen desktop
		this.currentTime = 0;
		this.play();
		this.style.opacity = '1';
	});

	$(document).on('mouseleave', 'video.video-thumb', function () {
		if (window.matchMedia('(max-width: 420px)').matches) {
			return;
		} // jen desktop
		this.pause();
		this.style.opacity = '0.5';
	});

	$(document).on('touchstart', 'video.video-thumb', function () {
		const $parentGroup = $(this).closest('.relative.group');
		if ($parentGroup.hasClass('expanded')) {
			return;
		}

		if (this.paused) {
			this.play();
			this.style.opacity = '1';
		}
		else {
			this.pause();
			this.currentTime = 0;
			this.style.opacity = '0.5';
		}
	});


	function isMobileView() {
		return window.matchMedia('(max-width: 420px)').matches;
	}


	$(document).on('click', '.group', function (e) {
		if (!isMobileView()) {
			return;
		}
		e.stopPropagation();

		const $group = $(this);
		const $panel = $group.find('.info-panel');
		const visible = $panel.is(':visible');

		$('.info-panel').hide();
		if (!visible) {
			$panel.show();
		}
	});

	$(document).on('mouseenter', '.group', function () {
		if (isMobileView()) {
			return;
		}
		$(this).find('.info-panel').show();
	});
	$(document).on('mouseleave', '.group', function () {
		if (isMobileView()) {
			return;
		}
		$(this).find('.info-panel').hide();
	});
}


$(function () {
	// 1) Inicializace lazy-load a hover-play funkcí
	initLazyLoadVideos();
	initHoverPlayVideos();

	// 2) Fallback: po 1 sekundě doplň zdroje všem videím, která IntersectionObserver nezpracoval
	setTimeout(function(){
		$('video.video-thumb').each(function(){
			var vid  = this;
			var $vid = $(this);
			if ($vid.data('loaded')) return;  // už máme načteno

			var webm = $vid.data('src-webm');
			var mp4  = $vid.data('src-mp4');

			if (webm) {
				$vid.append($('<source>', {
					src:  webm,
					type: 'video/webm'
				}));
			}
			if (mp4) {
				$vid.append($('<source>', {
					src:  mp4,
					type: 'video/mp4'
				}));
			}

			// přepni na preload metadata a načti první snímek
			$vid.attr('preload', 'metadata');
			vid.load();
			$vid.data('loaded', 1);
		});
	}, 1000);

	// 3) Úprava pozice info-panel po načtení metadat / při resize
	function updatePanel($group) {
		const h = $group.find('video').outerHeight();
		$group.find('.info-panel').css('top', h + 'px');
	}

	$('.relative.group').each(function () {
		const $group = $(this);
		const $video = $group.find('video');

		$video.on('loadedmetadata', () => updatePanel($group));
		$(window).on('resize', () => updatePanel($group));
		updatePanel($group);
	});

	// 4) Logika pro expand/clear videí na mobilu
	const $cards     = $('.relative.group');
	const $container = $cards.parent();

	function clearAll() {
		$cards
			.removeClass('expanded show-hint')
			.css('grid-row-start', '')
			.each(function () {
				const vid = $(this).find('video').get(0);
				if (vid) {
					vid.pause();
					vid.currentTime = 0;
				}
			});
	}

	$cards.on('click', function (e) {
		if ($(window).width() > 420) return; // jen mobil
		e.stopPropagation();

		const $this = $(this);
		const idx   = $container.find('.relative.group:visible').index($this);
		const cols  = window
			.getComputedStyle($container[0])
			.gridTemplateColumns.split(' ').length;
		const row   = Math.floor(idx / cols) + 1;

		if ($this.hasClass('expanded')) {
			$this.removeClass('expanded show-hint').css('grid-row-start', '');
			const vid = $this.find('video').get(0);
			if (vid) {
				vid.pause();
				vid.currentTime = 0;
			}
		} else {
			clearAll();
			$this
				.addClass('expanded show-hint')
				.css('grid-row-start', row);
			setTimeout(() => $this.removeClass('show-hint'), 1800);

			const vidEl = $this.find('video').get(0);
			if (vidEl) {
				vidEl.loop = true;
				vidEl.play().catch(err => console.warn('Nepodařilo se spustit video ve smyčce:', err));
			}
		}
	});

	$(document).on('click', clearAll);
	$(window).on('resize', function () {
		if ($(this).width() > 420) {
			clearAll();
		}
	});

	// 5) Iniciační případová studie (pokud existuje)
	if (typeof initCaseStudyPreview === 'function') {
		initCaseStudyPreview();
	}
});


// PREVIEW CASE STUDY IMAGE
function initCaseStudyPreview() {
	const $preview = $('#global-preview');
	const $previewImg = $('#preview-img');
	const $section = $('#case-study-section');
	let hideTimer;

	$('#case-study-list')
		.on('mousemove', 'li', function (e) {
			const offs = $section.offset();
			const relX = e.pageX - offs.left;
			const relY = e.pageY - offs.top;

			$preview.css({
				left:      relX + 'px',
				top:       relY + 'px',
				transform: 'translate(-50%, -50%)'
			});
		})
		.on('mouseenter', 'li', function () {
			clearTimeout(hideTimer);

			const src = $(this).find('.preview-source img').attr('src');

			if ($previewImg.attr('src') !== src) {
				$preview.css('opacity', 0);
				$previewImg.css('opacity', 0);

				const tempImg = new Image();
				tempImg.onload = function () {
					$previewImg.attr('src', src).fadeTo(200, 1);
					$preview.fadeTo(200, 1);
				};
				tempImg.src = src;
			}
			else {
				$preview.stop(true).fadeTo(200, 1);
				$previewImg.stop(true).fadeTo(200, 1);
			}
		});

	$section.on('mouseleave', function () {
		hideTimer = setTimeout(() => {
			$preview.stop(true).fadeTo(200, 0);
			$previewImg.stop(true).fadeTo(200, 0);
		}, 25);
	});
}


// BRAIN ANIMATION
function initBrainLogos() {
	const section = document.getElementById("tech-we-use");
	if (!section) return;

	const logos = Array.from(section.querySelectorAll(".brain-logo"));
	const MIN_W = 1024, MAX_W = 3440, GROWTH = 0.488;

	function prepareLogos() {
		logos.forEach(el => {
			const existingImg = el.querySelector("img");
			if (existingImg) el.removeChild(existingImg);
		});
		const W = window.innerWidth;
		const factor = 1 + GROWTH * (W - MIN_W) / (MAX_W - MIN_W);

		return logos.map(el => {
			const baseX = parseFloat(el.dataset.x);
			const baseY = parseFloat(el.dataset.y);
			const x = baseX * factor;
			const y = baseY * factor;
			const img = document.createElement("img");
			img.src = el.dataset.src;
			img.alt = "";
			img.classList.add("object-contain");

			const mqLg  = window.matchMedia("(min-width: 1024px)");
			const mq4xl = window.matchMedia("(min-width: 1920px)");

			function applyResponsiveHeight() {
				if (mq4xl.matches)      img.style.height = "calc(52.47px + 1.41vw)";
				else if (mqLg.matches)  img.style.height = "calc(34.25px + 2.36vw)";
				else                    img.style.height = "58.4px";
			}
			applyResponsiveHeight();
			mqLg.addEventListener("change", applyResponsiveHeight);
			mq4xl.addEventListener("change", applyResponsiveHeight);

			el.appendChild(img);
			return { el, x, y };
		});
	}

	function calculateScrollLength(dataCount) {
		const batchSize = 6;
		const batchCount = Math.ceil(dataCount / batchSize);
		const totalScroll = batchCount * window.innerHeight;
		return totalScroll / 6;
	}

	let brainTimeline = null;
	const mqLg = window.matchMedia("(min-width: 1024px)");

	function setupAnimation() {
		if (!mqLg.matches) {
			if (brainTimeline) {
				brainTimeline.scrollTrigger?.kill();
				brainTimeline.kill();
				brainTimeline = null;
			}
			return;
		}

		if (brainTimeline) {
			brainTimeline.scrollTrigger?.kill();
			brainTimeline.kill();
		}

		const prepared = prepareLogos();
		const scrollLength = calculateScrollLength(prepared.length);

		brainTimeline = gsap.timeline({
			scrollTrigger: {
				trigger: section,
				start:   "top top",
				end:     "+=" + scrollLength,
				scrub:   0,
				pin:     true,
				once:    true,
				onLeave(self) {
					const spacer = section.parentElement;
					if (!spacer || !spacer.classList.contains("pin-spacer")) return;
					const spacerTop = spacer.getBoundingClientRect().top + window.scrollY;
					requestAnimationFrame(() => {
						section.style.removeProperty("transform");
						spacer.style.removeProperty("height");
						spacer.style.removeProperty("padding");
						window.scrollTo({ top: spacerTop, behavior: "instant" });
						self.refresh();
					});
				}
			}
		});

		for (let i = 0; i < prepared.length; i += 6) {
			prepared.slice(i, i + 6).forEach((d, idx) => {
				brainTimeline.to(
					d.el,
					{ opacity: 1, x: d.x, y: d.y, duration: 0.5 },
					idx * 0.1 + i * 0.1
				);
			});
		}

		window.brainTimeline = brainTimeline;
	}

	mqLg.addEventListener("change", setupAnimation);
	setupAnimation();

	function jumpOver(hash) {
		const tl = window.brainTimeline;
		if (tl?.scrollTrigger) {
			tl.progress(1, false);
			tl.scrollTrigger.disable();
			ScrollTrigger.refresh();
		}
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				const target = document.querySelector(hash);
				if (target) {
					target.scrollIntoView({ behavior: "smooth", block: "start" });
					history.replaceState(null, "", hash);
				}
			});
		});
	}

	document
		.querySelectorAll('a[href$="#location"], a[href$="#references"]')
		.forEach(link => {
			link.addEventListener("click", e => {
				if (window.location.pathname !== link.pathname) return;
				e.preventDefault();
				jumpOver(link.hash);
			});
		});

	if (["#location", "#references"].includes(window.location.hash)) {
		jumpOver(window.location.hash);
	}

	window.addEventListener("resize", () => {
		clearTimeout(window._brainLogosResizeTimeout);
		window._brainLogosResizeTimeout = setTimeout(() => {
			setupAnimation();
			ScrollTrigger.refresh();
		}, 150);
	});
}

// BRAIN ID ANCHOR
$(function() {
	var $mobile  = $('section.lg\\:hidden.brain-section');
	var $desktop = $('section.lg\\:flex.brain-section');

	function assignAnchor() {
		if ($(window).width() < 1024) {
			$mobile.attr('id', 'tech-we-use');
			$desktop.removeAttr('id');
		} else {
			$desktop.attr('id', 'tech-we-use');
			$mobile.removeAttr('id');
		}
	}

	function scrollToHash() {
		if (window.location.hash === '#tech-we-use') {
			var $target = $('#tech-we-use');
			if ($target.length) {
				$('html, body').scrollTop( $target.offset().top );
			}
		}
	}

	assignAnchor();
	setTimeout(scrollToHash, 0);

	$(window).on('resize', function() {
		assignAnchor();
		setTimeout(scrollToHash, 0);
	});

	$(window).on('load', function() {
		assignAnchor();
		scrollToHash();
	});
});

// LOGO ROWS ANIMATION
function initLogoRowsAnimation() {
	const delayPerRow = 0.2;


	function isInViewport(el) {
		const rect = el.getBoundingClientRect();
		return (
			rect.top >= 0 &&
			rect.top <= (window.innerHeight || document.documentElement.clientHeight)
		);
	}


	function animateVisibleRows() {
		const rows = {};
		$('.logo-item').each(function () {
			const $el = $(this);
			if ($el.hasClass('animated-done')) {
				return;
			}

			const top = $el.offset().top;
			if (!rows[top]) {
				rows[top] = [];
			}
			rows[top].push($el);
		});

		const sortedRows = Object.keys(rows).sort((a, b) => a - b);
		sortedRows.forEach((top, i) => {
			const $firstEl = rows[top][0];
			if (isInViewport($firstEl[0])) {
				rows[top].forEach(($el) => {
					$el.addClass('animate__animated animate__fadeInUp animated-done');
					$el.css('--animate-delay', `${i * delayPerRow}s`);
				});
			}
		});
	}


	animateVisibleRows();
	$(window).on('scroll resize', animateVisibleRows);
}


$(document).ready(function () {
	// Feather icons
	feather.replace();

	// CASE STUDY PREVIEW
	runOnPage('homepage-default', initCaseStudyPreview);
	runOnPage('case-study-default', initCaseStudyPreview);

	// BRAIN ANIMATION
	runOnPage('homepage-default', initBrainLogos);
	runOnPage('case-study-default', initBrainLogos);

	// TEAM NAVIGATION
	runOnPage('homepage-default', initNavTabs);
	runOnPage('meet-the-team-default', initNavTabs);

	// SHOW TWO LINES PROFILES
	runOnPage('homepage-default', initTeamProfiles);
	runOnPage('meet-the-team-default', initTeamProfiles);

	// TEAM ANIMATION PLAY
	runOnPage('homepage-default', initHoverPlayVideos);
	runOnPage('meet-the-team-default', initHoverPlayVideos);

	// LOGO ROWS ANIMATION
	runOnPage('homepage-default', initLogoRowsAnimation);
	runOnPage('case-study-default', initLogoRowsAnimation);

	// PINK SMILE ANIMATION
	runOnPage('homepage-default', initPinkSmileAnimation);
	runOnPage('career-default', initPinkSmileAnimation);

	// LETS-WORK BUTTON
	const $whiteSection = $('#white-section');
	const $references = $('#references');
	const $letsWork = $('#letsWork');
	const $footerContent = $('#footerContent');
	let lastY = $(window).scrollTop();
	let angle = 0;
	const sensitivity = 0.15;

	if ($letsWork.length && document.documentElement.id !== 'homepage-default') {
		$letsWork.addClass('visible');
	}

	if ($letsWork.length && $footerContent.length) {
		function getOffsetFromFooter() {
			if (window.innerWidth <= 722) {
				return -455;
			}
			else if (window.innerWidth <= 2000) {
				return Math.round(-70 - window.innerWidth * 0.033);
			}
			else {
				return Math.round(10 - window.innerWidth * 0.073);
			}
		}


		function updateLetsWorkPosition() {
			const scrollTop = $(window).scrollTop();
			const windowHeight = $(window).height();
			const footerTop = $footerContent.offset().top;
			const letsWorkHeight = $letsWork.outerHeight();
			const bottomViewport = scrollTop + windowHeight - 20;
			const offsetFooter = getOffsetFromFooter();

			if (bottomViewport > footerTop - offsetFooter) {
				const newTop = footerTop - letsWorkHeight - offsetFooter;
				$letsWork.addClass('stuck').css({top: `${newTop}px`});
				if (window.innerWidth <= 722) {
					$letsWork.addClass('margin-small');
				}
				else {
					$letsWork.removeClass('margin-small');
				}
			}
			else {
				$letsWork.removeClass('stuck margin-small').css({top: ''});
			}
		}


		function updateIconColor() {
			if (!$whiteSection.length && !$references.length) {
				return;
			}

			let inWhite = false;
			if ($whiteSection.length) {
				const topW = $whiteSection.offset().top;
				const heightW = $whiteSection.outerHeight();
				const botW = topW + heightW;
				const viewBotW = $(window).scrollTop() + $(window).height();
				inWhite = viewBotW >= topW && viewBotW <= botW;
			}

			let inRefs = false;
			if ($references.length) {
				const topR = $references.offset().top;
				const heightR = $references.outerHeight();
				const botR = topR + heightR;
				const viewBotR = $(window).scrollTop() + $(window).height();
				inRefs = viewBotR >= topR && viewBotR <= botR;
			}

			if (inWhite || inRefs) {
				$letsWork.addClass('black-version');
			}
			else {
				$letsWork.removeClass('black-version');
			}
		}


		function resetRotationInstant() {
			$letsWork.css({transition: 'none', transform: 'rotate(0deg)'});
			angle = 0;
			setTimeout(() => $letsWork.css('transition', ''), 0);
		}


		$(window).on('scroll', function () {
			const currY = $(this).scrollTop();
			const delta = currY - lastY;
			if (currY <= 0) {
				resetRotationInstant();
			}
			else if (!$letsWork.hasClass('stuck')) {
				angle += delta * sensitivity;
				$letsWork.css('transform', `rotate(${angle}deg)`);
			}
			else {
				resetRotationInstant();
			}
			lastY = currY;
		});

		$(window).on('scroll resize', function () {
			updateLetsWorkPosition();
			updateIconColor();
		});

		updateLetsWorkPosition();
		updateIconColor();
	}
});


// PINK SMILE ANIMATION
function initPinkSmileAnimation() {
	function isInViewport(el) {
		const rect = el.getBoundingClientRect();
		return (
			rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
			rect.bottom > 0
		);
	}


	function animateSmiles() {
		$('.pink-smile').each(function () {
			const $el = $(this);
			if ($el.hasClass('animate')) {
				return;
			}
			if (isInViewport(this)) {
				$el.addClass('animate');
			}
		});
	}


	animateSmiles();
	$(window).on('scroll resize', animateSmiles);
}


// TEXT ANIMATION
$(function () {
	function isInViewport(el) {
		const rect = el.getBoundingClientRect();
		return (
			rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
			rect.bottom > 0
		);
	}


	function typeText($el, speed = 25) {
		const text = $el.text();
		$el.text('').css('opacity', '1');
		let i = 0;

		(function type() {
			if (i < text.length) {
				$el.append(text.charAt(i++));
				setTimeout(type, speed);
			}
		})();
	}


	function tryAnimateTyping() {
		$('.typing-target').each(function () {
			const $this = $(this);
			if ($this.data('typed')) {
				return;
			}

			if (isInViewport(this)) {
				typeText($this, 30);
				$this.data('typed', true);
			}
		});
	}


	tryAnimateTyping();
	$(window).on('scroll resize', tryAnimateTyping);
});